import React from 'react'
import {
  mtc,
  TextColors,
  ImageBackgroundColors,
} from '../../../utils/style-helpers'
import { Card, CardColors } from '../../atoms/card'
import { Heading, HeadingVariants } from '../../atoms/heading'
import { Image } from '../../atoms/image'
import { Text } from '../../atoms/text'
import { bodyStyles, imgStyles, styles } from './styles'

interface ILinkCardProps {
  children?: React.ReactNode
  className?: string
  color?: CardColors
  description: string
  imageAlt: string
  imageColor?: ImageBackgroundColors
  imageSrc: string
  imageWidth?: number
  subheader?: string
  title: string
}

export const LinkCard = ({
  children,
  className,
  color,
  description,
  imageAlt,
  imageColor,
  imageSrc,
  imageWidth,
  subheader,
  title,
}: ILinkCardProps) => {
  return (
    <Card className={mtc(styles(), className)} color={color}>
      <div className={mtc(imgStyles(), `${imageColor}`)}>
        <Image alt={imageAlt} width={imageWidth} src={imageSrc} />
      </div>

      <div className={mtc(bodyStyles())}>
        <header>
          <Heading variant={HeadingVariants.H4} className="text-neutral-500">
            {subheader}
          </Heading>
          <Heading variant={HeadingVariants.H3} className="text-neutral-900">
            {title}
          </Heading>
        </header>

        <Text color={TextColors.MUTED}>{description}</Text>

        {children}
      </div>
    </Card>
  )
}
